import { KuposSelectBox } from '../../../common';
import React from 'react';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import { withTranslation } from 'react-i18next';
import CommonService from '../../../../services/commonService';

function CuponeraHomeInputs({
  t,
  selectOptions,
  selectOptions2,
  onInputChange,
  onInputChange2,
  getOriginSelectedFilteredDestinations,
  home,
  history,
  actions,
  coupen,
  common,
  loading,
  allProps,
}) {
  const [inputs, setInputs] = useState({});
  console.log({ allProps });

  useEffect(() => {
    let origin = sessionStorage.getItem('cuponeraSourceCity');
    let destination = sessionStorage.getItem('cuponeraDestCity');
    if (origin && destination) {
      origin = JSON.parse(origin);
      destination = JSON.parse(destination);
      setInputs({
        source: origin,
        destination: destination,
      });
    }
  }, []);

  const onChange = (type, val) => {
    let error = `${type}Error`;

    setInputs({ ...inputs, [type]: val, [error]: null });

    console.log({ actions });

    if (type === 'source') {
      actions.pbSetSourceCity(val);
      sessionStorage.setItem('cuponeraSourceCity', JSON.stringify(val));
    } else {
      actions.pbSetDestinationCity(val);
      sessionStorage.setItem('cuponeraDestCity', JSON.stringify(val));
    }
  };

  const search = (e) => {
    loading(true);
    e.preventDefault();
    let errorCount = 0;

    let localInputs = CommonService.copyObject(inputs);
    if (!inputs.source) {
      localInputs['sourceError'] = 'VALIDATIONS.VALID_ORIGIN_CITY';
      errorCount++;
    }
    if (!inputs.destination) {
      localInputs['destinationError'] = 'VALIDATIONS.VALID_DESTINATION_CITY';
      errorCount++;
    }

    // console.log('common-----', actions);

    setInputs(localInputs);

    if (common && (!common.loginData || !common.loginData.id)) {
      actions.openCloseLoginModal(true);
      errorCount++;
    }

    if (errorCount <= 0) {
      history.push('/cuponera/seats');
    }
  };

  return (
    <form onSubmit={search} className='couponera_home_inputs_wrapper'>
      <div className="home-selection-input-boxes couponera_home_inputs">
        <div className="home-selection-input-box font10">
          <span className="label font10 bold-text margin-B5 d-inline-block">
            {t('HOME.ORIGIN')}
          </span>
          <KuposSelectBox
            reactSelect
            selectType="origin"
            options={selectOptions}
            selectedOption={inputs.source}
            // onChange={onSourceChange}
            onChange={(val) => onChange('source', val)}
            onInputChange={onInputChange}
            icon="/images/search-bar/search-bar-origin.svg"
            hideArrow={true}
            error={inputs.sourceError ? true : false}
            errorMessage={t(inputs.sourceError)}
            placeholder={t('HOME.ORIGIN')}
            height={40}
            t={t}
          />
        </div>

        <div className="home-selection-input-box font10">
          <span className="label font10 bold-text margin-B5 d-inline-block">
            {t('HOME.DESTINATION')}
          </span>
          <KuposSelectBox
            reactSelect
            // selectRef={destinationRef}
            selectType="destination"
            options={
              inputs.source
                ? getOriginSelectedFilteredDestinations(selectOptions2, inputs.source)
                : null
            }
            selectedOption={inputs.destination}
            //   onChange={onDestinationChange}
            onChange={(val) => onChange('destination', val)}
            onInputChange={onInputChange2}
            icon="/images/search-bar/search-bar-destination.svg"
            hideArrow={true}
            error={inputs.destinationError ? true : false}
            errorMessage={t(inputs.destinationError)}
            placeholder={t('HOME.DESTINATION')}
            height={40}
            t={t}
          />
        </div>

        <div className="home-selection-input-box font12 datebox mt-1">
          <button
            className="kupos-button home-selection-input-button "
            onClick={search}
            type="onSubmit"
          >
            <img
              className="icon-size"
              src="/images/icons/home/icon_search-white.png"
              alt={t('TRANSLATIONS.ICON_SEARCH_WHITE')}
            />{' '}
            <span>{t('HOME.SEARCH')}</span>
          </button>
        </div>
      </div>
    </form>
  );
}

function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common,
  };
}

export default connect(mapStateToProps)(withTranslation('common')(CuponeraHomeInputs));



// WEBPACK FOOTER //
// ./src/features/common/Cuponera/CuponeraInputs/index.js